import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/caac_windDir.png'
import _imports_1 from '@/assets/images/vk_zl_line.png'
import _imports_2 from '@/assets/images/dangerIcon.png'
import _imports_3 from '@/assets/images/error-icon.png'
import _imports_4 from '@/assets/images/star.png'
import _imports_5 from '@/assets/images/standard.png'
import _imports_6 from '@/assets/images/standard2.png'
import _imports_7 from '@assets/images/backIcon.png'
import _imports_8 from '@assets/images/star.png'
import _imports_9 from '@assets/images/standard.png'


const _hoisted_1 = { class: "flying-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "alarm-container" }
const _hoisted_4 = { class: "header-lf flex-row" }
const _hoisted_5 = { class: "header-rt flex-row" }
const _hoisted_6 = { class: "fps-container wind-dirct-container" }
const _hoisted_7 = { class: "fps-container" }
const _hoisted_8 = { class: "img-box" }
const _hoisted_9 = { class: "all-time" }
const _hoisted_10 = { class: "font-DIN" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "progress-box" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "new-grad-container"
}
const _hoisted_15 = { class: "grad-inner" }
const _hoisted_16 = { class: "grad-body" }
const _hoisted_17 = { class: "grad-time-box" }
const _hoisted_18 = { class: "time-left-group" }
const _hoisted_19 = { class: "time-box-container" }
const _hoisted_20 = { class: "inner-box" }
const _hoisted_21 = { class: "time-text font-DIN" }
const _hoisted_22 = { class: "inner-box" }
const _hoisted_23 = { class: "time-text" }
const _hoisted_24 = { class: "warn-row" }
const _hoisted_25 = { class: "main-content-row" }
const _hoisted_26 = { class: "left-column" }
const _hoisted_27 = { class: "score-eval-row" }
const _hoisted_28 = { class: "info-btn score-card flex-row" }
const _hoisted_29 = { class: "vl-txt font-DIN" }
const _hoisted_30 = { class: "info-btn score-card flex-row" }
const _hoisted_31 = { class: "radar-box info-btn" }
const _hoisted_32 = { class: "deviation-row" }
const _hoisted_33 = { class: "right-column" }
const _hoisted_34 = { class: "info-btn eval-card flex-row" }
const _hoisted_35 = { class: "summary-card info-btn" }
const _hoisted_36 = { class: "summary-content" }
const _hoisted_37 = { class: "summary-text" }
const _hoisted_38 = { class: "summary-card info-btn" }
const _hoisted_39 = { class: "summary-content" }
const _hoisted_40 = { class: "suggest-text" }
const _hoisted_41 = {
  class: "grad-btn-container",
  style: {"justify-content":"space-between"}
}
const _hoisted_42 = { class: "btn-box" }
const _hoisted_43 = {
  key: 2,
  class: "grad-container"
}
const _hoisted_44 = { class: "grad-inner" }
const _hoisted_45 = { class: "grad-body" }
const _hoisted_46 = { class: "grad-time-box" }
const _hoisted_47 = { class: "time-box-container info-btn flex-row" }
const _hoisted_48 = { class: "inner-box" }
const _hoisted_49 = { class: "time-text font-DIN" }
const _hoisted_50 = { class: "warn-box" }
const _hoisted_51 = { class: "score-container" }
const _hoisted_52 = { class: "lf-box" }
const _hoisted_53 = { class: "lft-tp-box info-btn flex-row" }
const _hoisted_54 = { class: "vl-txt" }
const _hoisted_55 = { class: "lft-bt-box info-btn flex-row" }
const _hoisted_56 = { class: "rgt-box info-btn" }
const _hoisted_57 = { class: "grad-base-info" }
const _hoisted_58 = {
  class: "grad-btn-container flex-row",
  style: {"justify-content":"space-between"}
}
const _hoisted_59 = { class: "btn-box" }

import { ref } from 'vue'
import useFlying from './index'
import {NProgress} from 'naive-ui'
import  useMouseHide from '@/hooks/useMouseHide'
import flyDeviationInfo from '@/components/modules/flight/flyInfo/flyDeviationInfo.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 定义组件的属性
},
  emits: {
    // 定义组件的事件
},
  setup(__props, { emit: __emit }) {

const { isMouseHidden } = useMouseHide(3000)
const timeBoxRef = ref<HTMLDivElement | null>(null);
const timeBox = ref<HTMLDivElement | null>(null);
const progressRef = ref<HTMLDivElement | null>(null);
const flyCanvasRef = ref<HTMLDivElement | null>(null);
const gradCanvasRef = ref<HTMLDivElement | null>(null);
const flyDeviationInfoRef = ref<any>(null);
const gradeFlyDeviationInfoRef = ref<any>(null);
const props = __props

const emits = __emit

const {
    sceneImage,
    progressValue,
    receive,
    sum,
    speed,
    currentFile,
    maxFile,
    uavStatusList,
    connectIcon,
    currentTime,
    isShowAlarm,
    currentPage,
    gradInfo,
    gradScore,
    evaluate,
    handleRestart,
    currentStepIndex,
    totalSeconds,
    $enum,
    lockStatus,
    lockIcon,
    chanceCount,
    handleBack,
    handleBackCallback,
    currentSeconds,
    handleLock,
    gradTotalTime,
    onGround,
    engineInitialized,
    pageVisible,
    loadingProgess,
    loading3D,
    fpsStatus,
    connectStatus,
    isReady,
    collisionAlarm,
    crash,
    windDirection,
    trainingId,
    isOnlineSystem,
    handleOpenPDF,
    currentWindSpeed,
    aiCoachSettlementData,
    handleOpenSettingFullscreen,
    flyDeviationViewMode,
    flyingInfo,
    permissionLevel,
    openFlyReplay,
} = useFlying(emits,timeBox,progressRef,flyCanvasRef,gradCanvasRef,flyDeviationInfoRef,gradeFlyDeviationInfoRef);

return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vkm_remoteStatus = _resolveComponent("vkm-remoteStatus")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentPage) == 1)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: _unref(sceneImage),
          receive: _unref(receive),
          sum: _unref(sum),
          speed: _unref(speed),
          currentFile: _unref(currentFile),
          maxFile: _unref(maxFile),
          progressValue: _unref(loadingProgess),
          title: _unref(loading3D).title,
          description: _unref(loading3D).description,
          pageType: _unref(loading3D).pageType
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _unref(isShowAlarm) || _unref(collisionAlarm)]
      ]),
      _createElementVNode("div", {
        class: "caac-header flex-row",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "iconfont-line vk_prevleft_line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleBackCallback)('icon'))),
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uavStatusList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(index  <=  _unref(currentStepIndex)?'uav-status-item active-status':'uav-status-item'),
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item), 1),
              (index != _unref(uavStatusList)?.length - 1)
                ? (_openBlock(), _createBlock(_component_vkm_svg, {
                    key: 0,
                    "icon-name": index < _unref(currentStepIndex)?'current_step':'uncurrent_step' ,
                    class: "icon"
                  }, null, 8, ["icon-name"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "img-box" }, [
              _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_0,
                alt: ""
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(currentWindSpeed)) + "m/s", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_1,
                alt: ""
              }, null, -1)),
              (_unref(fpsStatus) < 30)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "denger-icon",
                    src: _imports_2,
                    alt: "",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleOpenPDF) && _unref(handleOpenPDF)(...args)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, [
              _cache[9] || (_cache[9] = _createTextVNode("FPS:")),
              _createElementVNode("span", {
                class: _normalizeClass({'danger':_unref(fpsStatus) < 30})
              }, _toDisplayString(_unref(fpsStatus)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "all_time",
              class: "icon"
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(gradTotalTime)), 1)
          ]),
          _createElementVNode("img", {
            class: "connect-icon",
            src: _unref(connectIcon),
            alt: "",
            style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
          }, null, 12, _hoisted_11),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "设置",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont-fill vk_sz_fill header-icon",
                style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : !_unref(isReady) ? 'not-allowed !important' : 'pointer !important' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(handleOpenSettingFullscreen)(_unref(isReady))))
              }, null, 4)
            ]),
            _: 1
          })
        ])
      ], 4),
      _createElementVNode("div", {
        class: "countdown-container",
        style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'default !important' })
      }, [
        _createElementVNode("div", {
          ref_key: "timeBoxRef",
          ref: timeBoxRef,
          class: "progress-content"
        }, [
          (_unref(totalSeconds) != -1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-time time-container':'time-container'),
                ref_key: "timeBox",
                ref: timeBox
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(currentTime)), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dv3" }, null, -1)),
            (_unref(totalSeconds) != -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-dv4 dv4':'dv4'),
                  ref_key: "progressRef",
                  ref: progressRef
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ], 4),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(lockStatus) == _unref($enum).SWITCH_STATUS.ON && !_unref(onGround)?'none-click-btn lock-container':'lock-container' ),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleLock) && _unref(handleLock)(...args)))
      }, [
        _createElementVNode("img", {
          src: _unref(lockIcon),
          alt: "",
          style: _normalizeStyle({ cursor: _unref(isMouseHidden) ? 'none !important' : 'pointer !important' })
        }, null, 12, _hoisted_13)
      ], 2),
      _createVNode(_component_vkm_remoteStatus, {
        isRemoteConnected: !!_unref(connectStatus),
        isReady: _unref(isReady)
      }, null, 8, ["isRemoteConnected", "isReady"]),
      (_unref(permissionLevel) == 1)
        ? (_openBlock(), _createBlock(flyDeviationInfo, {
            key: 0,
            ref_key: "flyDeviationInfoRef",
            ref: flyDeviationInfoRef,
            isReady: _unref(isReady),
            flyingInfo: _unref(flyingInfo),
            viewMode: 'card',
            style: {"display":"none"}
          }, null, 8, ["isReady", "flyingInfo"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _unref(currentPage) == 2]
    ]),
    (_unref(currentPage) == 3 && _unref(permissionLevel) == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("span", null, "成绩")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_scrollbar, {
                class: "grad-scrollbar",
                "wrap-class": "grad-scrollbar-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "clock",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(gradTotalTime)), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "time-box-container",
                        onClick: _cache[4] || (_cache[4] = ()=>{flyDeviationViewMode.value = _unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? _unref($enum).FlyDeviationViewMode.曲线 : _unref($enum).FlyDeviationViewMode.卡片})
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "vk_qh_line",
                            class: "icon"
                          }),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(flyDeviationViewMode) === _unref($enum).FlyDeviationViewMode.卡片 ? '曲线' : '卡片'), 1)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_24, _cache[11] || (_cache[11] = [
                      _createElementVNode("div", { class: "warn-box" }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: ""
                        }),
                        _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分")
                      ], -1)
                    ]), 512), [
                      [_vShow, _unref(crash)]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper star-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "得分")
                          ], -1)),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(gradScore)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "img-box flex-row" }, [
                            _createElementVNode("div", { class: "icon-wrapper check-icon" }, [
                              _createElementVNode("img", {
                                src: _imports_5,
                                alt: ""
                              })
                            ]),
                            _createElementVNode("span", null, "成绩")
                          ], -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(_unref(evaluate)?'green':'red')
                          }, _toDisplayString(_unref(evaluate)?'合格':'不合格'), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", {
                          class: "electronic-pile-container",
                          ref_key: "gradCanvasRef",
                          ref: gradCanvasRef
                        }, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(flyDeviationInfo, {
                          ref_key: "gradeFlyDeviationInfoRef",
                          ref: gradeFlyDeviationInfoRef,
                          isReady: true,
                          flyingInfo: _unref(gradInfo),
                          viewMode: _unref(flyDeviationViewMode)
                        }, null, 8, ["flyingInfo", "viewMode"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "img-box flex-row" }, [
                          _createElementVNode("div", { class: "icon-wrapper thumb-icon" }, [
                            _createElementVNode("img", {
                              src: _imports_6,
                              alt: ""
                            })
                          ]),
                          _createElementVNode("span", null, "AI飞行评价")
                        ], -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['eval-text', _unref(aiCoachSettlementData)?.rating === '优秀' ? 'green' : _unref(aiCoachSettlementData)?.rating === '良好' ? 'yellow' : 'red'])
                        }, _toDisplayString(_unref(aiCoachSettlementData)?.rating || (_unref(evaluate) ? '合格' : '不合格')), 3)
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "ability-radar-box info-btn" }, [
                        _createElementVNode("div", { id: "echartBox" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "飞行总结")
                        ], -1)),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(aiCoachSettlementData)?.flightConclusion || '暂无总结'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-header" }, [
                          _createElementVNode("span", { class: "summary-title" }, "AI教员训练建议")
                        ], -1)),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(aiCoachSettlementData)?.trainingSuggestion || '暂无建议'), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "grad-countdown" }, null, -1)),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_vkn_button, {
                  label: "飞行回放",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(openFlyReplay)
                }, {
                  icon: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "iconfont-line vk_hf_line" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                (_unref(isOnlineSystem))
                  ? (_openBlock(), _createBlock(_component_vkn_button, {
                      key: 0,
                      label: "重新开始",
                      type: "tertiary",
                      size: "medium",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(handleRestart)(false)))
                    }, {
                      icon: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vkn_button, {
                  label: "返回",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(handleBackCallback)
                }, {
                  icon: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("img", { src: _imports_7 }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(currentPage) == 3 && _unref(permissionLevel) == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("span", null, "成绩")
            ], -1)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_vkm_svg, {
                      "icon-name": "clock",
                      class: "icon"
                    }),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(gradTotalTime)), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_50, _cache[23] || (_cache[23] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: ""
                  }, null, -1),
                  _createElementVNode("p", null, "飞机已坠毁，请谨慎飞行，成绩为0分", -1)
                ]), 512), [
                  [_vShow, _unref(crash)]
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_8 }),
                      _createElementVNode("span", null, "得分")
                    ], -1)),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(gradScore)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "img-box flex-row" }, [
                      _createElementVNode("img", { src: _imports_9 }),
                      _createElementVNode("span", null, "评价")
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(_unref(evaluate)?'vl-txt green':'vl-txt red')
                    }, _toDisplayString(_unref(evaluate)?'合格':'不合格'), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", {
                    class: "inner-box electronic-pile-container",
                    ref_key: "gradCanvasRef",
                    ref: gradCanvasRef
                  }, null, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(flyDeviationInfo, {
                  isReady: true,
                  flyingInfo: _unref(gradInfo),
                  viewMode: 'card'
                }, null, 8, ["flyingInfo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "grad-countdown" }, null, -1)),
              _createElementVNode("div", _hoisted_59, [
                (_unref(isOnlineSystem))
                  ? (_openBlock(), _createBlock(_component_vkn_button, {
                      key: 0,
                      label: "重新开始",
                      type: "tertiary",
                      size: "medium",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(handleRestart)(false)))
                    }, {
                      icon: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_vkn_button, {
                  label: "返回",
                  type: "tertiary",
                  size: "medium",
                  onClick: _unref(handleBackCallback)
                }, {
                  icon: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createElementVNode("img", { src: _imports_7 }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})